export const de = {
  nav: { home: "Start", pricing: "Preise", demo: "Demo", signin: "Mit LinkedIn anmelden", signout: "Abmelden" },
  hero: { title: "Steigern Sie Ihre LinkedIn-Reichweite mit privaten, unsichtbaren Pods", subtitle: "Wir ordnen Sie bestehenden Invite-only-Pods im Hintergrund zu. Keine Automatisierung. Faire Rotation, Tageslimits und Punkte für qualitatives Engagement." },
  cta: { pricing: "Preise ansehen", demo: "Demo ansehen" },
  features: {
    invite: { title: "Qualität nur auf Einladung", desc: "Unsichtbares Matching zu kuratierten Pods." },
    fair: { title: "Fair & konform", desc: "Manueller Klick zu LinkedIn. Keine Bots." },
    points: { title: "Punkte & Limits", desc: "2 Einreichungen/Tag. Like=1, Kommentar=3." }
  },
  how: { title: "So funktioniert's", step1: "1. Zugang anfordern und onboarden.", step2: "2. Wir ordnen Sie automatisch bestehenden Pods zu.", step3: "3. Teilen, manuell engagieren, Punkte sammeln, Reichweite ausbauen." },
  compliance: { title: "Compliance", copy: "Keine Automatisierung von Likes/Kommentaren. Nutzer klicken immer zu LinkedIn. Matching und Rotation serverseitig gemäß AGB." },
  faq: {
    title: "FAQ",
    platforms_q: "Welche Plattformen?",
    platforms_a: "Nur LinkedIn in v1.",
    submissions_q: "Wie viele Einreichungen?",
    submissions_a: "Bis zu 2 aktive Einreichungen pro Tag.",
    points_q: "Wie werden Punkte berechnet?",
    points_a: "Like = 1 Punkt, Kommentar = 3 Punkte. Ein Minimum ist nötig zum Einreichen."
  },
  pricing: {
    title: "Einfache Preise",
    subtitle: "Plan wählen und Zugang anfordern. Jederzeit kündbar.",
    starter: "Starter",
    pro: "Pro",
    team: "Team",
    price_starter: "19€/Monat",
    price_pro: "49€/Monat",
    price_team: "Kontakt",
    feat_curated: "Kuratierten Pods",
    feat_priority: "Priorisiertes Matching",
    feat_analytics_basic: "Einfache Analysen",
    feat_analytics_adv: "Erweiterte Analysen",
    feat_seats: "Mehrere Sitze",
    feat_limits: "Individuelle Limits",
    feat_sla: "SLA-Support",
    cta: "Zugang anfordern"
  },
  demo: {
    title: "Demo (read-only)",
    subtitle: "Demonstration des manuellen Engagement-Flows und des Punktesystems.",
    queue_title: "Engagement-Warteschlange",
    points_title: "Punkte-Übersicht",
    open: "Öffnen"
  },
  footer: { copy: "© EngagePods. v1 nur LinkedIn. Invite-only Pods." }
} as const;
